<template>
  <v-text-field
    class="input-text-search"
    autocomplete="off"
    hide-details="auto"
    v-bind:error-messages="violations"
    v-bind:loading="isLoading"
    v-bind:placeholder="placeholder"
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
  >
    <template v-slot:prepend-inner>
      <div class="icon" />
    </template>
    <template v-slot:append-outer>
      <button
        class="clear"
        v-if="isShowButtonClear"
        type="button"
        v-on:click="clearSearchText"
      />
    </template>
  </v-text-field>
</template>

<script>

/**
 * @description Компонент текстового поиска.
 * @type {any}
 */
export default {
  computed: {
    /**
     * Показывать кнопку очистки поля поиска
     * @returns {boolean}
     */
    isShowButtonClear() {
      return this.value.length > 0;
    },
  },
  methods: {
    /**
     * Очистка поля поиска
     */
    clearSearchText() {
      this.$emit('input', '');
    },
  },
  props: {
    isLoading: { default: () => false, type: Boolean },
    /**
     * @description Текст заполнитель.
     * @type {string}
     */
    placeholder: { default: () => '', type: String },
    /**
     * @description Значение.
     * @type {string}
     */
    value: { required: true, type: String },
    /**
     * @description Нарушения.
     * @type {string[]}
     */
    violations: { default: () => [], type: Array },
  },
};
</script>

<style scoped>
.input-text-search {
  font-weight: 400;
}
.icon {
  margin-top: 5px;
  margin-right: 5px;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/search-black.svg");
  background-size: contain;
  width: 15px;
  height: 15px;
}
.clear {
  margin-top: 5px;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/exit-dark-grey.svg");
  background-size: contain;
  width: 15px;
  height: 15px;
}
</style>
